import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { getUserProfileResult } from '../queries';
import { profileConst } from '..';

export const useUserProfileResult = () => {
  const { query } = useRouter();
  const userId = query?.id as string | undefined;


  return useQuery({
    queryKey: [profileConst.queryKeys.USER_PROFILE_RESULTS, userId || 'self'],
    queryFn: getUserProfileResult(userId)
  });
};
